var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.97266 11.1031L2.85391 11.9844L3.97266 10.8594L3.09141 9.97813L1.97266 11.1031ZM6.62891 11.6719L7.87891 11.6719V13.5469L6.62891 13.5469V11.6719ZM0.378906 6.04688H2.25391V7.29688H0.378906L0.378906 6.04688ZM7.87891 1.70313L7.87891 4.17812L8.50391 4.54063C9.27891 4.99062 9.75391 5.81563 9.75391 6.70312C9.75391 8.08437 8.63516 9.20312 7.25391 9.20312C5.87266 9.20312 4.75391 8.08437 4.75391 6.70312C4.75391 5.81563 5.23516 4.99062 6.00391 4.54063L6.62891 4.17812L6.62891 1.70313L7.87891 1.70313ZM9.12891 0.453125L5.37891 0.453125V3.45938C4.26016 4.10938 3.50391 5.31563 3.50391 6.70312C3.50391 8.77188 5.18516 10.4531 7.25391 10.4531C9.32266 10.4531 11.0039 8.77188 11.0039 6.70312C11.0039 5.31563 10.2477 4.10938 9.12891 3.45938V0.453125ZM12.2539 6.04687H14.1289V7.29687H12.2539V6.04687ZM10.5289 10.8656L11.6477 11.9906L12.5289 11.1094L11.4039 9.99062L10.5289 10.8656Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/highlight.4dca4673bfc0776ba8e9266329bd2493.svg";
export { ForwardRef as ReactComponent };